import { useSelector } from 'react-redux';
import { LanguageIsoInfo } from '../../redux/localReports/localReports.proptype';
import { selectLanguageList } from '../../selectors';

export const useLanguages = (): LanguageIsoInfo[] => {
  const languages = useSelector(selectLanguageList);

  return languages;
};
